import { useState } from 'react';

import classNames from '@rio-cloud/rio-uikit/classNames';
import RadioButton from '@rio-cloud/rio-uikit/RadioButton';

import AnimationDelayControl from './controls/AnimationDelayControl';
import AnimationDurationControl from './controls/AnimationDurationControl';
import AnimationEasingControl from './controls/AnimationEasingControl';
import AnimationLoopingControl from './controls/AnimationLoopingControl';
import AnimationPlaybackControl from './controls/AnimationPlaybackControl';
import AnimationRepeatControl from './controls/AnimationRepeatControl';
import type {
    AnimationDelay,
    AnimationDuration,
    AnimationEasing,
    AnimationLooping,
    AnimationRepeat,
} from './controls/animationControlOptions';

const AnimationsFadeExample = () => {
    const [currentAnimationType, setCurrentAnimationType] = useState('fade-out');
    const [currentAnimationDelay, setCurrentAnimationDelay] = useState<AnimationDelay>('no-delay');
    const [currentAnimationDuration, setCurrentAnimationDuration] = useState<AnimationDuration>('1s');
    const [currentAnimationRepeat, setCurrentAnimationRepeat] = useState<AnimationRepeat>('infinite');
    const [currentAnimationEasing, setCurrentAnimationEasing] = useState<AnimationEasing>('linear');
    const [currentAnimationLooping, setCurrentAnimationLooping] = useState<AnimationLooping>('loop');
    const [playAnimation, setPlayAnimation] = useState(false);

    const animationClassName = classNames(
        playAnimation &&
            classNames(
                `animated-${currentAnimationDuration}`,
                currentAnimationDelay !== 'no-delay' && `animated-delay-${currentAnimationDelay}`,
                currentAnimationRepeat,
                currentAnimationEasing
            ),
        playAnimation && currentAnimationLooping !== 'one-time' && currentAnimationLooping,
        playAnimation && currentAnimationType
    );

    return (
        <>
            <div className='display-flex justify-content-center'>
                <RadioButton
                    name='fade-type'
                    onChange={() => {
                        setCurrentAnimationType('fade-in');
                        setPlayAnimation(false);
                    }}
                    checked={currentAnimationType === 'fade-in'}
                    inline
                >
                    fade-in
                </RadioButton>
                <RadioButton
                    name='fade-type'
                    onChange={() => {
                        setCurrentAnimationType('fade-out');
                        setPlayAnimation(false);
                    }}
                    checked={currentAnimationType === 'fade-out'}
                    inline
                >
                    fade-out
                </RadioButton>
            </div>
            <hr />
            <AnimationDurationControl
                value={currentAnimationDuration}
                onChange={value => {
                    if (!value) {
                        return;
                    }

                    setCurrentAnimationDuration(value);
                    setPlayAnimation(false);
                }}
            />
            <hr />
            <AnimationDelayControl
                value={currentAnimationDelay}
                onChange={value => {
                    if (!value) {
                        return;
                    }

                    setCurrentAnimationDelay(value);
                    setPlayAnimation(false);
                }}
            />
            <hr />
            <AnimationEasingControl
                value={currentAnimationEasing}
                onChange={value => {
                    if (!value) {
                        return;
                    }

                    setCurrentAnimationEasing(value);
                    setPlayAnimation(false);
                }}
            />
            <hr />
            <AnimationRepeatControl
                value={currentAnimationRepeat}
                onChange={value => {
                    if (!value) {
                        return;
                    }

                    setCurrentAnimationRepeat(value);
                    setPlayAnimation(false);
                }}
            />
            <hr />
            <AnimationLoopingControl
                value={currentAnimationLooping}
                onChange={value => {
                    if (!value) {
                        return;
                    }

                    setCurrentAnimationLooping(value);
                    setPlayAnimation(false);
                }}
            />
            <hr />
            <AnimationPlaybackControl
                isPlaying={playAnimation}
                onPlay={() => setPlayAnimation(true)}
                onReset={() => setPlayAnimation(false)}
            />
            <hr />
            <div className='display-flex flex-column align-items-center justify-content-center height-300'>
                <div className={animationClassName}>
                    <svg
                        className='margin-5 margin-left-0 scale-200'
                        width='50'
                        height='50'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d={
                                'M0 50V0h50v50H0zm45.3-23.95c0-4.55-3.7-8.25-8.25-8.25s-8.25 ' +
                                '3.7-8.25 8.25 3.7 8.25 8.25 8.25 8.25-3.7 8.25-8.25zm-23.6 7.' +
                                '8h5.05V18.2H21.7v15.65zm-8-15.65H5.25v15.65h4.9V27.6l4.25 ' +
                                '6.25h5.35l-4.1-6.25c.45-.15.85-.4 1.15-.7 1.1-.9 1.8-2.3 1.8-3.8 ' +
                                '0-2.7-2.2-4.9-4.9-4.9z'
                            }
                            fillRule='evenodd'
                        />
                    </svg>
                </div>
            </div>
            <hr />
            <div className='display-flex justify-content-center'>
                <code className='code hidden-empty'>{animationClassName}</code>
            </div>
        </>
    );
};

export default AnimationsFadeExample;
